/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Unit_Gif_MessagesInputs */



/**
* | output |
* | --- |
* | "GIF messages" |
*
* @param {Perks_Unit_Gif_MessagesInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_unit_gif_messages = /** @type {((inputs?: Perks_Unit_Gif_MessagesInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Unit_Gif_MessagesInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("GIF-сообщений")
	return /** @type {LocalizedString} */ ("GIF messages")
});